import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { Link } from "react-router-dom";

const ADD_FUNDS_ITEMS = [
    {
        id: "transfer",
        title: "Transfer",
        desc: "Transfer assets among different accounts",
        // meta: "Transferable: 0 USDT",
        icon: "ri-arrow-left-right-line",
        link: "/user_profile/wallet/cross_margin",
    },
    {
        id: "onchain",
        title: "Onchain Deposit",
        desc: "Deposit crypto from other exchanges/wallets to AGCX",
       
        icon: "ri-download-cloud-2-line",
        link: "/asset_managemnet/deposit",
    },
    {
        id: "p2p",
        title: "P2P Trading (Coming Soon)",
        desc: "Zero fees, 400+ payment methods, and seamless crypto trading",
        // meta: "Coming Soon",
        icon: "ri-exchange-2-line",
        link: null,
    },
    // {
    //     id: "buyusd",
    //     title: "Buy with USD",
    //     desc: "Buy and sell crypto via Apple Pay, cards, Google Pay, bank transfers, and more",
    //     icon: "ri-global-line",
    //     link: null,
    // },
    // {
    //     id: "redeem",
    //     title: "Redeem AGCXCode",
    //     desc: "For asset transfer among AGCX accounts only",
    //     icon: "ri-barcode-box-line",
    //     link: null,
    // },
];

export default function AddFundsModal({ open, onClose, onTransferClick }) {
    const [expanded, setExpanded] = useState(false);

    useEffect(() => {
        if (!open) {
            setExpanded(false);
            return;
        }
        const prev = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        return () => {
            document.body.style.overflow = prev;
        };
    }, [open]);

    useEffect(() => {
        if (!open) return;
        const onKey = (e) => {
            if (e.key === "Escape") onClose();
        };
        document.addEventListener("keydown", onKey);
        return () => document.removeEventListener("keydown", onKey);
    }, [open, onClose]);

    if (!open || typeof document === "undefined") return null;

    const visible = expanded ? ADD_FUNDS_ITEMS : ADD_FUNDS_ITEMS.slice(0, 3);

    return createPortal(
        <div
            className="agcx-add-funds-overlay"
            role="presentation"
            onMouseDown={(e) => {
                if (e.button !== 0) return;
                if (e.target === e.currentTarget) onClose();
            }}
        >
            <div className="agcx-add-funds-modal" role="dialog" aria-modal="true" aria-label="Add Funds">
                <div className="agcx-add-funds-head">
                    <h3 className="agcx-add-funds-title">Add Funds</h3>
                    <button type="button" className="agcx-add-funds-close" onClick={onClose} aria-label="Close">
                        ×
                    </button>
                </div>

                <div className="agcx-add-funds-body">
                    {visible.map((it) => {
                        const inner = (
                            <>
                                <span className="agcx-add-funds-icon" aria-hidden>
                                    <i className={it.icon} aria-hidden />
                                </span>
                                <span className="agcx-add-funds-meta">
                                    <span className="agcx-add-funds-item-title">{it.title}</span>
                                    <span className="agcx-add-funds-desc">{it.desc}</span>
                                    {it.meta ? <span className="agcx-add-funds-sub">{it.meta}</span> : null}
                                </span>
                            </>
                        );

                        /* "Transfer" card — opens the Funds Transfer modal */
                        // if (it.id === "transfer") {
                        //     return (
                        //         <button
                        //             key={it.id}
                        //             type="button"
                        //             className="agcx-add-funds-card"
                        //             onClick={() => {
                        //                 onClose();
                        //                 if (onTransferClick) onTransferClick();
                        //             }}
                        //         >
                        //             {inner}
                        //         </button>
                        //     );
                        // }

                        /* Items with a route link */
                        if (it.link) {
                            return (
                                <Link key={it.id} to={it.link} className="agcx-add-funds-card" onClick={onClose}>
                                    {inner}
                                </Link>
                            );
                        }

                        /* Default: plain button */
                        return (
                            <button key={it.id} type="button" className="agcx-add-funds-card">
                                {inner}
                            </button>
                        );
                    })}

                    {/* <button
                        type="button"
                        className="agcx-add-funds-more"
                        onClick={() => setExpanded((v) => !v)}
                    >
                        {expanded ? "View Less" : "View More"}
                    </button> */}
                </div>
            </div>
        </div>,
        document.body
    );
}
